import { AppLocale } from 'shared-ui';

import { Messages } from 'core/global.types';

import enMessages from './data/en.json';
import plMessages from './data/pl.json';

type KeyAsValue<T> = { [P in keyof T]: P };

const keysToValues = <T extends Record<string, unknown>>(source: T): KeyAsValue<typeof source> => {
  return (Object.keys(source) as Array<keyof T>).reduce((accumulated, current) => {
    accumulated[current] = current;
    return accumulated;
  }, {} as KeyAsValue<typeof source>);
};

export const AppMessages = {
  ...keysToValues(enMessages),
  ...keysToValues(plMessages),
};

export const translations: Record<AppLocale, Record<Messages, string>> = {
  [AppLocale.en]: enMessages,
  [AppLocale.pl]: plMessages,
};
